import { withDefaultContextAsSelectedProject } from './api-default-context';
import { getStatementIdUtil } from 'utils/statement-export-utils';
import { getStore } from 'store/store';

export const createRevisionSectionAssignment = ({
  revisionId,
  sectionIds,
  userIds,
  isOCR,
}) => {
  const { selectedStatement } = getStore().getState().data;
  const postDataObj = { revisionId, userIds };
  postDataObj[isOCR ? 'bookmarkIds' : 'sectionIds'] = sectionIds;

  const URL = isOCR
    ? `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/bookmark/assignments/batch`
    : `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/section/assignments/batch`;

  return withDefaultContextAsSelectedProject().post(URL, postDataObj);
};

export const unassignRevisionSectionAssignment = ({
  revisionId,
  sectionIds,
  userIds,
  isOCR,
}) => {
  const { selectedStatement } = getStore().getState().data;
  const postDataObj = { revisionId, userIds };
  postDataObj[isOCR ? 'bookmarkIds' : 'sectionIds'] = sectionIds;

  const URL = isOCR
    ? `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/bookmark/unassign/all`
    : `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/section/unassign/all`;

  return withDefaultContextAsSelectedProject().post(URL, postDataObj);
};
